import { render, staticRenderFns } from "./LightCharacterCard.vue?vue&type=template&id=f6326bf6&scoped=true&"
import script from "./LightCharacterCard.vue?vue&type=script&lang=js&"
export * from "./LightCharacterCard.vue?vue&type=script&lang=js&"
import style0 from "./LightCharacterCard.vue?vue&type=style&index=0&id=f6326bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6326bf6",
  null
  
)

export default component.exports